import { Button, TextArea } from "@resource/atlas";
import cx from "clsx";
import { FunctionComponent, useState } from "react";

import { Category } from "./categories";
import CategoryMultiSelection from "./CategoryMultiSelection";

export type SubmitDetailedFeedbackCallback = (
  freeformFeedback: string,
  categories: Category["id"][]
) => void;

type DetailedFeedbackProps = {
  submitting?: boolean;
  buttonText?: string;
  title: string;
  categories: Category[];
  onSubmitDetailedFeedback: SubmitDetailedFeedbackCallback;
};

const DetailedFeedback: FunctionComponent<DetailedFeedbackProps> = ({
  submitting,
  categories,
  buttonText = "Done",
  title,
  onSubmitDetailedFeedback,
}) => {
  const [categoriesSelected, selectCategories] = useState<
    Array<Category["id"]>
  >([]);
  const [freeformFeedback, setFreeformFeedback] = useState<string>("");
  const addCategory = (category: string): void => {
    selectCategories([...categoriesSelected, category]);
  };
  const removeCategory = (category: string): void =>
    selectCategories(categoriesSelected.filter((c) => c !== category));
  return (
    <div className="space-y-3">
      <h3 className="text-h3">{title}</h3>
      <CategoryMultiSelection
        categories={categories}
        addCategory={addCategory}
        removeCategory={removeCategory}
        categoriesSelected={categoriesSelected}
      />
      <div className={cx("mt-5")}>
        <TextArea
          className="w-full"
          placeholder="Anything else you'd like to share?"
          value={freeformFeedback}
          onChange={(event): void => {
            setFreeformFeedback(event);
          }}
        />
      </div>
      <div className={cx("w-full flex justify-end mt-3")}>
        <Button
          className="!rounded-full"
          variant="primary"
          disabled={submitting}
          onClick={(): void => {
            onSubmitDetailedFeedback(freeformFeedback, categoriesSelected);
          }}
        >
          {buttonText}
        </Button>
      </div>
    </div>
  );
};

export default DetailedFeedback;
